const config = {
  initiateLoginEndpoint: process.env.REACT_APP_START_LOGIN_PAGE_URL || process.env.TAB_ENDPOINT + '/auth-start.html',
  clientId: process.env.REACT_APP_CLIENT_ID || process.env.AAD_APP_CLIENT_ID,
  apiEndpoint: process.env.REACT_APP_FUNC_ENDPOINT || process.env.FUNC_ENDPOINT || '',
  apiName: process.env.REACT_APP_FUNC_NAME || process.env.FUNC_NAME,
  sharedUrl: process.env.REACT_APP_SHAREDURL_URL || process.env.SHAREDURL_URL || 'https://urlsavewebservicemr-agdte5g9chgvgaej.eastus-01.azurewebsites.net/UserUrlAPI/',
  env: process.env.REACT_APP_TEAMSFX_ENV ?? process.env.TEAMSFX_ENV ?? 'undefined'
}

export default config

